import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmComponent,
  ConfirmDialogData,
} from '../dashboard-layout/includes/dialog/confirm/confirm.component';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) {}
  confirmDialog(data: ConfirmDialogData): Observable<boolean> {    
    return this.dialog
      .open(ConfirmComponent, {
        width: '400px',
        data,
      })
      .afterClosed();
  }

  /**
   * Same as `confirmDialog`, but emits from `beforeClosed()`, i.e. synchronously
   * inside the button's click handler. Use it when the follow-up needs the
   * browser's user-activation (e.g. `Notification.requestPermission()`), which
   * is lost by the time the close animation finishes.
   */
  confirmDialogOnClick(data: ConfirmDialogData): Observable<any> {
    return this.dialog
      .open(ConfirmComponent, {
        width: '400px',
        data,
      })
      .beforeClosed();
  }
}
